import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { Auth0Provider } from "@auth0/auth0-react";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";

import es from "javascript-time-ago/locale/es";
import ru from "javascript-time-ago/locale/ru";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/es";

import footer_es from "./translations/es/footer.json";
import footer_en from "./translations/en/footer.json";

import { setupGlobalAxios } from './services/axiosGlobalConfig';

setupGlobalAxios();

// Configurar TimeAgo
TimeAgo.addDefaultLocale(es);
TimeAgo.addLocale(ru);

// Configurar i18next
i18next.init({
  interpolation: { escapeValue: false },
  lng: localStorage.getItem("lng") || "es",
  resources: {
    es: { footer: footer_es },
    us: { footer: footer_en },
  },
});

// Configuración de Auth0
const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  cacheLocation: "localstorage",
  useRefreshTokens: true,
  authorizationParams: {
    redirect_uri: process.env.REACT_APP_LOGIN_URL,
  },
};

// Filtrar warnings específicos de ResizeObserver
const resizeObserverWarning =
  "ResizeObserver loop completed with undelivered notifications";
const filterConsole =
  (originalFn) =>
  (...args) => {
    const msg = typeof args[0] === "string" ? args[0] : "";
    if (msg.includes(resizeObserverWarning)) return;
    originalFn(...args);
  };

console.error = filterConsole(console.error);
console.warn = filterConsole(console.warn);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Auth0Provider {...auth0Config}>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </Auth0Provider>
  </React.StrictMode>,
);
